module.exports = __webpack_public_path__ + "img/hotdog-top-001-3.8ca0530d.jpg";